module.exports = __webpack_public_path__ + "logo.png?17f20c3d4f845b9fcedf87f95c324987";


//////////////////
// WEBPACK FOOTER
// ./src/img/home/logo.png
// module id = 709
// module chunks = 20